<template>
  <div v-if="wishlistCount === 0" class="max-w-[250px] text-md">
    <SFTooltipInfo
      :title="$t('tooltip.wishlist.title')"
      :description="$t('tooltip.wishlist.description')"
    />
  </div>
  <div v-else class="w-[300px]">
    <!-- TODO: Wishlist dropdown -->
  </div>
</template>

<script setup lang="ts">
import { useWishlist } from '#storefront/composables'
import SFTooltipInfo from '~/components/ui/SFTooltipInfo.vue'

const { count: wishlistCount } = useWishlist()
</script>
